var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (description, title) {
      pug_html = pug_html + "\u003Ch4\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fh4\u003E\u003Cp\u003E" + (pug.escape(null == (pug_interp = description) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cdiv class=\"ngdialog-buttons\"\u003E\u003Cbutton class=\"btn btn-primary float-right\" ng-click=\"confirm(1)\"\u003EAccept\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-danger float-left\" ng-click=\"closeThisDialog(0)\"\u003ECancel\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "description" in locals_for_with ?
        locals_for_with.description :
        typeof description !== 'undefined' ? description : undefined, "title" in locals_for_with ?
        locals_for_with.title :
        typeof title !== 'undefined' ? title : undefined));
    ;;return pug_html;};
module.exports = template;